import styled from "styled-components";

import * as Dropdown from "ds/Dropdown";

export const Label = styled(Dropdown.Label)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--mode-text-neutral-weakest);
`;

export const Trigger = styled(Dropdown.Trigger)`
  display: flex;
  gap: 8px;
  align-items: center;
  width: max-content;
  color: var(--mode-text-neutral-weakest);
`;
